import * as paper from 'paper';
import {Point, Path, Segment, Curve} from "paper";
import {DisplayFunctions} from "./displayFunctions";
import {MathFunctions, SimpleLine, LongSimpleSegment} from "./mathHelper";
import {DrawData} from "../drawData";
import {DrawDisplayData} from "../drawDisplayData";

interface IPathClickOptions {
    mouseOverAllowBoolFunc(): any;

    doDisplayMenuBoolFunc(group: any): any;

    onClickMenuMakerFunc(group: any): any;
}

interface ILabelClickOptions {
    onEnterFunc(value: any): any;
}

export class CurveItem {
    static moveCurve(drawDataObj: DrawData, curve: any, delta: paper.Point, ignoreLimits: boolean = false) {
        if (delta.x === 0 && delta.y === 0) {
            return;
        }
        var allowedVector = curve.getNormalAt(curve.length / 2);
        delta = delta.project(allowedVector);
        if (curve.segment1.pairedCurve) {
            let newPoint = DisplayFunctions.setMaxDeltaByOppositeSide(curve.segment1, delta);
            if (newPoint == null) {
                return;
            }

            delta = newPoint;
        }

        var priorCurve = curve.previous, nextCurve = curve.next, v1, v2;
        //Preserve angles and change neighbor curve lengths. Curve length may change if connecting angles converge.
        v1 = CurveItem.makeOrRestoreVectorFromCurve(priorCurve);
        v2 = MathFunctions.reverseVector(CurveItem.makeOrRestoreVectorFromCurve(nextCurve));
        //align movement:
        v1.angle = DrawData.roundToAllowedAngle(v1.angle);
        v2.angle = DrawData.roundToAllowedAngle(v2.angle);

        var lineMidP = MathFunctions.getLineMidpoint(curve);
        var newLineMidP = MathFunctions.addVectors(lineMidP, delta);
        var lineVector = MathFunctions.getLineVector(curve);
        lineVector.angle = DrawData.roundToAllowedAngle(lineVector.angle);
        var newPoint2 = MathFunctions.getInterceptPoint(newLineMidP, lineVector, nextCurve.point1, v2);
        var newPoint1 = MathFunctions.getInterceptPoint(newLineMidP, lineVector, priorCurve.point1, v1);

        var newPriorLength = MathFunctions.getScalarLengthAlong(MathFunctions.getVectorBetween(priorCurve.point1, newPoint1), v1);
        var newNextLength = MathFunctions.getScalarLengthAlong(MathFunctions.getVectorBetween(nextCurve.point2, newPoint2), v2);
        //Check to make sure angle didn't change:
        var curAngle1 = DrawData.roundToAllowedAngle(MathFunctions.calculateAngleFromLines(curve.previous, curve)),
            curAngle2 = DrawData.roundToAllowedAngle(MathFunctions.calculateAngleFromLines(curve, curve.next));
        var newLine = new SimpleLine(newPoint1, newPoint2);
        var newPrevLine = new SimpleLine(curve.previous.point1, newPoint1);
        var newNextLine = new SimpleLine(newPoint2, curve.next.point2);
        var newAngle1 = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(newPrevLine, newLine), 2);
        var newAngle2 = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(newLine, newNextLine), 2);
        if ((newAngle2 !== curAngle2)) {// || (newAngle2 != curAngle2)){

            let hyp = MathFunctions.getLineBetween(nextCurve.point2, newLineMidP);
            let line = MathFunctions.getLineBetween(newLineMidP, MathFunctions.addVectors(newLineMidP, lineVector));
            let angle = MathFunctions.calculateAngleFromLines(hyp, line);
            let midPExtendLength = MathFunctions.getLineLength(hyp) * (Math.sin(MathFunctions.convertToRadians(180 - (curAngle2 + angle))) / Math.sin(MathFunctions.convertToRadians(curAngle2)));
            newPoint2 = MathFunctions.addVectors(newLineMidP, lineVector.normalize(midPExtendLength));
        } else {
            newPoint2 = MathFunctions.addVectors(v2.normalize(newNextLength), nextCurve.point2);
        }
        if ((newAngle1 !== curAngle1)) {// || (newAngle2 != curAngle2)){
            let hyp = MathFunctions.getLineBetween(priorCurve.point1, newLineMidP);
            let line = MathFunctions.getLineBetween(newLineMidP, MathFunctions.addVectors(newLineMidP, MathFunctions.reverseVector(lineVector)));
            let angle = MathFunctions.calculateAngleFromLines(hyp, line);
            let midPExtendLength = MathFunctions.getLineLength(hyp) * (Math.sin(MathFunctions.convertToRadians(180 - (curAngle1 + angle))) / Math.sin(MathFunctions.convertToRadians(curAngle1)));
            newPoint1 = MathFunctions.addVectors(newLineMidP, MathFunctions.reverseVector(lineVector.normalize(midPExtendLength)));
        } else {
            newPoint1 = MathFunctions.addVectors(v1.normalize(newPriorLength), priorCurve.point1);
        }

        newPoint1 = MathFunctions.roundVector(newPoint1);
        newPoint2 = MathFunctions.roundVector(newPoint2);

        //limit movement:
        if (ignoreLimits || !CurveItem.limitDeltaByBounds(drawDataObj, curve, newPoint1, newPoint2, v1, v2, delta)) {
            newLine = new SimpleLine(newPoint1, newPoint2);
            newPrevLine = new SimpleLine(curve.previous.point1, newPoint1);
            newNextLine = new SimpleLine(newPoint2, curve.next.point2);
            newAngle1 = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(newPrevLine, newLine), 2);
            newAngle2 = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(newLine, newNextLine), 2);
            if ((newAngle1 !== curAngle1) || (newAngle2 !== curAngle2)) {

                let hyp = MathFunctions.getLineBetween(nextCurve.point2, newLineMidP);

                let line = MathFunctions.getLineBetween(newLineMidP, MathFunctions.addVectors(newLineMidP, lineVector));
                let angle = MathFunctions.calculateAngleFromLines(hyp, line);
                let midPExtendLength = MathFunctions.getLineLength(hyp) * (Math.sin(MathFunctions.convertToRadians(180 - (curAngle2 + angle))) / Math.sin(MathFunctions.convertToRadians(curAngle2)));
                newPoint2 = MathFunctions.addVectors(newLineMidP, lineVector.normalize(midPExtendLength));

                hyp = MathFunctions.getLineBetween(priorCurve.point1, newLineMidP);

                line = MathFunctions.getLineBetween(newLineMidP, MathFunctions.addVectors(newLineMidP, MathFunctions.reverseVector(lineVector)));
                angle = MathFunctions.calculateAngleFromLines(hyp, line);
                midPExtendLength = MathFunctions.getLineLength(hyp) * (Math.sin(MathFunctions.convertToRadians(180 - (curAngle1 + angle))) / Math.sin(MathFunctions.convertToRadians(curAngle1)));
                newPoint1 = MathFunctions.addVectors(newLineMidP, MathFunctions.reverseVector(lineVector.normalize(midPExtendLength)));
            }
            drawDataObj.setCurvePoints(curve, newPoint1, newPoint2);
        }
    }

    static makeOrRestoreVectorFromCurve(curve: any) {
        if (!curve.movingCurveVector) {
            curve.movingCurveVector = MathFunctions.getVectorBetween(curve.point1, curve.point2);
        }
        return curve.movingCurveVector;
    }

    static limitDeltaByBounds(drawDataObj: DrawData, curve: any, newPoint1: any, newPoint2: any, v1: any, v2: any, delta: any) {
        var limitDelta = false;

        var allowedPoint1 = MathFunctions.addVectors(curve.point1, MathFunctions.getVectorBetweenPoints(curve.point1, curve.previous.point1).normalize(DisplayFunctions.PIXEL_INCH_RATE / 2));
        var allowedPoint2 = MathFunctions.addVectors(curve.point2, MathFunctions.getVectorBetweenPoints(curve.point2, curve.next.point2).normalize(DisplayFunctions.PIXEL_INCH_RATE / 2));
        v2 = MathFunctions.reverseVector(v2);
        if (MathFunctions.getScalarLengthAlong(MathFunctions.getVectorBetweenPoints(curve.previous.point1, newPoint1), v1) <= (DisplayFunctions.PIXEL_INCH_RATE / 2)) {//checking bounds: overlapped.
            limitDelta = true;
            newPoint1 = allowedPoint1;
        }
        if (MathFunctions.getScalarLengthAlong(MathFunctions.getVectorBetweenPoints(newPoint2, curve.next.point2), v2) <= (DisplayFunctions.PIXEL_INCH_RATE / 2)) {
            limitDelta = true;
            newPoint2 = allowedPoint2;
        }
        if (!limitDelta) {
            var newCurveVector = MathFunctions.getVectorBetweenPoints(newPoint1, newPoint2);
            if (MathFunctions.getScalarLengthAlong(newCurveVector, MathFunctions.getVectorBetweenPoints(curve.point1, curve.point2)) <= (DisplayFunctions.PIXEL_INCH_RATE / 2)) {
                limitDelta = true;
                var intPoint = MathFunctions.getInterceptPoint(newPoint1, v1, newPoint2, v2);
                if (!intPoint) {
                    return true;
                }
                newPoint1 = MathFunctions.addVectors(intPoint, MathFunctions.reverseVector(v1).normalize(DisplayFunctions.PIXEL_INCH_RATE / 2));
                newPoint2 = MathFunctions.addVectors(intPoint, v2.normalize(DisplayFunctions.PIXEL_INCH_RATE / 2));
            }
        }

        if (limitDelta) {
            var maxDeltaA = MathFunctions.getVectorBetween(allowedPoint1, newPoint1);
            var maxDeltaB = MathFunctions.getVectorBetween(allowedPoint2, newPoint2);

            var maxDelta = new Point(MathFunctions.closestToZero(maxDeltaA.x, maxDeltaB.x), MathFunctions.closestToZero(maxDeltaA.y, maxDeltaB.y));
            CurveItem.moveCurve(drawDataObj, curve, maxDelta);
        }
        return limitDelta;
    }

    static createCurveLineDrawData(curveLineData: any) {
        var curveLineLengthInInches = curveLineData.curveLineLengthInInches,
            curveLineOffsetInInches = curveLineData.curveLineOffsetInInches;
        var curve = curveLineData.segment.path.curves[curveLineData.segment.index];
        var curveLength = this.getComplexCurveLength(curve);
        if (!curveLineLengthInInches || curveLineLengthInInches >= DisplayFunctions.RoundPixelToInch(curveLength)) {
            curveLineLengthInInches = DisplayFunctions.RoundPixelToInch(curveLength);
            curveLineOffsetInInches = 0;
        }
        if (!curveLineOffsetInInches) {
            curveLineOffsetInInches = 0;
        }
        if (curveLineLengthInInches + curveLineOffsetInInches > DisplayFunctions.RoundPixelToInch(curveLength)) {
            curveLineOffsetInInches = DisplayFunctions.RoundPixelToInch(curveLength) - curveLineLengthInInches;
        }

        curveLineData.curveLineLengthInInches = curveLineData.curveLineLengthInInches ? curveLineLengthInInches : 0;
        curveLineData.curveLineOffsetInInches = curveLineOffsetInInches;

        return {
            curve: curve,
            length: DisplayFunctions.RoundInchToPixel(curveLineData.curveLineLengthInInches),
            offset: DisplayFunctions.RoundInchToPixel(curveLineData.curveLineOffsetInInches),
            thickness: DrawDisplayData.EDGE_PIXEL_THICKNESS,
            labelOffsetToo: false,
            pathShift: DrawDisplayData.EDGE_BAR_SHIFT,
            pathStyle: DrawDisplayData.EDGE_STYLE,
            skipLabelText: false,
            pathClickOptions: <IPathClickOptions | null>null,
            ignoreCornerRadius: <boolean | undefined>undefined,
            labelText: <string | undefined>undefined,
            labelStyle: <any>undefined,
            labelPosition: <string | undefined>undefined,
            labelClickOptions: <ILabelClickOptions | null>null
        };
    }

    static getComplexCurveLength(curve: any) {
        return this.getComplexCurveLengthFromFullCurve(DrawData.getFullComplexCurve(curve));
    }

    static getComplexCurveLengthFromFullCurve(startEnd: any) {
        var startSeg = startEnd.startSegment,
            endSeg = startEnd.endSegment;
        var sum = 0;
        var curSeg = startSeg;
        while (curSeg != endSeg) {
            sum += curSeg.path.curves[curSeg.index].length;
            curSeg = curSeg.next;
        }
        return sum;
    }

    static getThicknessShiftVectorOnComplexCurveAt(startEnd: any, point: any) {
        //var segArr = startEnd.createSegArr();
        var retVal: any, offset;
        retVal = startEnd.forAllCurves(function (curve: any) {
            if (point.equals(curve.point1)) {
                return curve.getNormalAt(0);
            }
            if (point.equals(curve.point2)) {
                return curve.getNormalAt(curve.length);
            }//Math.floor(curve.length));}
            offset = curve.getOffsetOf(point);
            if (!retVal && offset) {
                return curve.getNormalAt(offset);
            }
            return null;
        });
        return retVal ? retVal : new Point(0, 0);
    }

    static getThicknessShiftVectorOnComplexCurveAtOffset(startEnd: any, offset: any) {
        //var segArr = startEnd.createSegArr();
        var retVal: any, lastCurve: any;
        retVal = startEnd.forAllCurves(function (curve: any) {
            var curveLength = curve.length;
            if (curveLength > offset) {
                return curve.getNormalAt(offset);
            }
            offset -= curveLength;
            lastCurve = curve;
        });
        // was return retVal ? retVal : lastCurve.getNormalAt(Math.floor(curve.length));
        return retVal ? retVal : lastCurve.getNormalAt(Math.floor(lastCurve.length));
    }

    static createComplexCurvePath(dataObj: any) {
        var segArr;
        var shiftVector;
        var offset = dataObj.offset ? dataObj.offset : 0;//field
        var thickness = dataObj.thickness;//field
        var thicknessShiftStatic = false;
        var thicknessShift;
        let startEnd: any = undefined;
        if (dataObj.ignoreCornerRadius && !DrawData.isRadius(dataObj.curve.segment1)) { //use simple line:
            var line = DrawData.makeSimpleCounterLine(dataObj.curve.segment1);
            segArr = [new Segment(line.point1), new Segment(line.point2)];
            var curve = new Curve(segArr[0], segArr[1]);
            shiftVector = curve.getNormalAt(curve.length / 2);
            thicknessShiftStatic = true;
            if (thickness)
                thicknessShift = shiftVector.normalize(thickness);
            //TODO: simple-line offset
            offset = 0;
        } else {
            startEnd = DrawData.getFullComplexCurve(dataObj.curve);
            segArr = startEnd.createSegArr();
            var totalLength = CurveItem.getComplexCurveLengthFromFullCurve(startEnd);
            var length = totalLength;//field
            if (dataObj.length) {
                length = dataObj.length;
            }
            dataObj.length = length;
            segArr = DrawData.copySegArr(segArr);
            if (totalLength == length) {
                segArr = this.capEnds(segArr);
            } else {
                segArr = this.capLHSAtPoint(segArr, offset);
                segArr = this.capRHSAtPoint(segArr, length);
            }
        }
        var p = new Path(dataObj.pathStyle ? dataObj.pathStyle : {strokeColor: 'black'});
        p.addSegments(segArr);//field
        var midPLength = p.length / 2 + offset;
        if (!shiftVector) {
            shiftVector = this.getThicknessShiftVectorOnComplexCurveAtOffset(startEnd, midPLength);
        }
        shiftVector = shiftVector.normalize((dataObj.pathShift == null) ? DrawData.MEASUREMENT_LINE_SHIFT : dataObj.pathShift);//field
        dataObj.labelShiftVector = shiftVector;
        if (thickness) {

            var revPathArr = this.reversePathSegArr(segArr);
            for (var i = 0; i < revPathArr.length; i++) {
                if (!thicknessShiftStatic)
                    thicknessShift = this.getThicknessShiftVectorOnComplexCurveAt(startEnd, revPathArr[i].point).normalize(thickness);

                revPathArr[i].point = MathFunctions.addVectors(revPathArr[i].point, thicknessShift);
            }
            p.addSegments(revPathArr);
            p.closed = true;
            if (!dataObj.pathStyle) {
                p.fillColor = new paper.Color('red');
            }
        }
        p.translate(shiftVector);
        p.name = 'path';
        return p;
    }

    static capEnds(segArr: any) {
        segArr[0].handleIn = new Point(0, 0);
        segArr[segArr.length - 1].handleOut = new Point(0, 0);
        return segArr;
    }

    static capLHSAtPoint(segArr: any, offset: any) {
        if (offset > 0) {
            var tempPath = new Path(segArr);
            if (offset < tempPath.length) {
                var tp2 = tempPath.splitAt(offset);
                if (tp2) {
                    tp2.remove();
                    segArr = tp2.segments;
                }
            }
            tempPath.remove();
        }
        segArr[0].handleIn = new Point(0, 0);
        return segArr;
    }

    static capRHSAtPoint(segArr: any, offset: any) {
        if (offset > 0) {
            var tempPath = new Path(segArr);
            if (offset < tempPath.length) {
                var tp2 = tempPath.splitAt(offset);
                if (tp2) {
                    tp2.remove();
                }
            }
            tempPath.remove();
            segArr = tempPath.segments;
        }
        segArr[segArr.length - 1].handleOut = new Point(0, 0);
        return segArr;
    }

    static reversePathSegArr(segArr: any) {
        var retVal = [];
        var curSeg, handleIn, handleOut;
        for (var i = segArr.length - 1; i >= 0; i--) {
            curSeg = segArr[i];

            handleIn = curSeg.handleOut ? (curSeg.handleOut) : new Point(0, 0);
            handleOut = curSeg.handleIn ? (curSeg.handleIn) : new Point(0, 0);
            retVal[(segArr.length - 1) - i] = new Segment(new LongSimpleSegment(curSeg.point, handleIn, handleOut));
        }
        return retVal;
    }
}
